import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconTrashFill';
/** Renders an SVG icon. */
const SvgTrashFill = ({
  size,
  'aria-hidden': ariaHidden,
  tone,
  UNSAFE_className,
  UNSAFE_style,
  ...rest
}: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M11 5a3 3 0 0 1 3-3h4a3 3 0 0 1 3 3v1h5.5a1.5 1.5 0 0 1 0 3h-21a1.5 1.5 0 1 1 0-3H11zm8 1h-6V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1zM6.033 12.588A1.5 1.5 0 0 1 7.53 11h16.94a1.5 1.5 0 0 1 1.497 1.588l-.803 13.647A4 4 0 0 1 21.171 30H10.83a4 4 0 0 1-3.993-3.765zM20 15a1 1 0 1 0-2 0v8a1 1 0 1 0 2 0zm-7-1a1 1 0 0 1 1 1v8a1 1 0 1 1-2 0v-8a1 1 0 0 1 1-1"
      />
    </svg>
  );
};
SvgTrashFill.displayName = displayName;
export default SvgTrashFill;
